
import React from "react";
import Contact from "./Contact";
import Navbar from "./Navbar";
import Footer from "./Footer";

export function ContactPage() {
  return (
   <>
   <Navbar/>
   <Contact/>
   <Footer/>
   </>
  );
}
